module.exports = __webpack_public_path__ + "img/new_invite_pic.93dabe44.png";